import './App.css';
import HeaderComponent from './components/Header';
import FooterComponent from './components/Footer';
import HotPersonageSideberComponent from './components/HotPersonageSideber';
import IncreaseSidebarComponent from './components/IncreaseSidebar';
import StockChart from './Chart'; 
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Flex, Layout, Table, Row, Col, Button, Dropdown, Menu } from 'antd';
import unit from './unit';
import { useLocation, useParams } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons';

const { Content } = Layout;

const Particulars = (props) => {
    const [type, setType] = useState(1); // 当前选中的上级按钮类型（1: 十大流通股东，2: 十大股东）
    const [columns, setColumns] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [exitColumns, setExitColumns] = useState([]); 
    const [exitDataSource, setExitDataSource] = useState([]); 
    const [dayList, setDayList] = useState([]); 
    const [date, setDate] = useState(''); 
    const [selectedRowKey, setSelectedRowKey] = useState(null); // 选中的行ID
    const childRef = useRef(null);
    const location = useLocation(); 
    const { code } = useParams(); 
    const scrollContainerRef = useRef(null);
    const dateTagRefs = useRef({}); // 存储日期标签的ref
    
    console.log(code,'code');

    useEffect(() => {
        setColumns([
            {
                title: '序列',
                dataIndex: 'index',
                key: 'index',
                className: 'center-align',
            },
            {
                title: '股票名称',
                dataIndex: 'name',
                key: 'name',
                className: 'gudong',
                render: (text, record) => (
                    <a 
                        href={`/detail/${record.code}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className={selectedRowKey === record.code ? 'selected-link' : ''}
                    >
                        {text}
                    </a>
                ),
            },
            {
                title: '持仓数（股）',
                dataIndex: 'num',
                key: 'num',
                className: 'center-align',
            },
            {
                title: '持仓占比',
                dataIndex: 'percent',
                key: 'percent',
                className: 'center-align',
            },
            {
                title: '较上期变化',
                dataIndex: 'change_percent',
                key: 'change_percent',
                className: 'center-align',
            },
        ]);

        setExitColumns([
            {
                title: '序列',
                dataIndex: 'index2',
                key: 'index2',
                className: 'center-align',
            },
            {
                title: '股票名称',
                dataIndex: 'name2',
                key: 'name2',
            },
            {
                title: '上期持仓（股）',
                dataIndex: 'num2',
                key: 'num2',
                className: 'center-align',
            },
            {
                title: '持仓占比',
                dataIndex: 'percent2',
                key: 'percent2',
                className: 'center-align',
            
            },
        ]);
    }, [selectedRowKey]);

    const onLogin = () => {
        childRef.current.onLogin();
    };

    const getHotList = useCallback(() => {
        const path = '/dxwapp/gegu/gudongInfo';
        console.log(code,'11111');
        unit.httpGet(path, 
        {
            "code": code,
            "filter_type": 0,
            "apiversion": 8.9,
            "type": 0,
            "date": date,
            "appVersion": "5.0702"
        }, (data) => {
            let dataDetail = data.position_detail.data;

            // 处理日期列表
            if (dataDetail.filters.length > 0) {
                const sortedFilters = dataDetail.filters.sort((a, b) => b.v - a.v);

                const formattedData = sortedFilters.map(item => ({
                    day: item.v,
                    show: item.t,
                }));
                setDayList(formattedData);
                if (date === '' && formattedData.length > 0) {
                    setDate(formattedData[0].day);
                }
            }

            // 处理持仓明细数据
            if (dataDetail.holder_list.list.length > 0) {
                let _dataSource = [];
                for (let i = 0; i < dataDetail.holder_list.list.length; i++) {
                    let tmp = {};
                    tmp['index'] = i + 1;
                    tmp['name'] = dataDetail.holder_list.list[i][0].text;
                    tmp['code']  = dataDetail.holder_list.list[i][0].param.code;
                    tmp['num'] = dataDetail.holder_list.list[i][1].text;
                    tmp['percent'] = dataDetail.holder_list.list[i][2].text;

                    // 处理较上期变化字段的颜色
                    let changeText = dataDetail.holder_list.list[i][3].text;
                    if (changeText === '新进') {
                        tmp['change_percent'] = <span className="newColor">{changeText}</span>;
                    } else if (changeText[0] === '+') {
                        tmp['change_percent'] = <span className="addColor">{changeText}</span>;
                    } else if (changeText[0] === '-') {
                        tmp['change_percent'] = <span className="delColor">{changeText}</span>;
                    } else {
                        tmp['change_percent'] = changeText;
                    }

                    _dataSource.push(tmp);
                }
                setDataSource(_dataSource);
            }

            // 处理退出股东数据
            if (dataDetail.withdrew_list.length > 0) {
                let _exitDataSource = [];
                for (let i = 0; i < dataDetail.withdrew_list.length; i++) {
                    let tmp = {};
                    tmp['index2'] = i + 1;
                    tmp['name2'] = dataDetail.withdrew_list[i].name;
                    tmp['num2'] = dataDetail.withdrew_list[i].holder;
                    tmp['percent2'] = dataDetail.withdrew_list[i].percent;
                    _exitDataSource.push(tmp);
                }
                setExitDataSource(_exitDataSource);
            }else{
                setExitDataSource([]);
            }
        });
    }, [type, date, code]);

    // 切换上级按钮（十大流通股东/十大股东）
    const onTabsChange = (key) => {
        setType(parseInt(key));
        if (dayList.length > 0) {
            setDate(dayList[0].day);
        }
        setSelectedRowKey(null);
    };

    // 点击日期标签或下拉菜单中的日期
    const onTagClick = (v) => {
        setDate(v);
        setSelectedRowKey(null);
        
        // 滚动到选中的日期标签
        scrollToSelectedDate(v);
    };

    // 滚动到选中的日期标签
    const scrollToSelectedDate = (day) => {
        // 确保DOM已经更新
        setTimeout(() => {
            const targetElement = dateTagRefs.current[day];
            const container = scrollContainerRef.current;
            
            if (targetElement && container) {
                // 计算目标元素相对于容器的位置
                const targetLeft = targetElement.offsetLeft;
                const containerWidth = container.offsetWidth;
                const targetWidth = targetElement.offsetWidth;
                
                // 滚动到目标位置，使元素居中显示
                container.scrollLeft = targetLeft - (containerWidth / 2) + (targetWidth / 2);
            }
        }, 0);
    };

    useEffect(() => {
        getHotList();
    }, [type, date, code, getHotList]); 

    // 表格行点击事件处理函数
    const onRowClick = (record, event) => {
        event.stopPropagation();
        setSelectedRowKey(record.code);
    };

    // 创建下拉菜单
    const menu = (
        <Menu>
            {dayList.map((item) => (
                <Menu.Item 
                    key={item.day} 
                    onClick={() => onTagClick(item.day)}
                    className={date === item.day ? "active-menu-item" : ""}
                >
                    {item.show}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <div className="App">
            <Flex gap="middle" wrap>
                <Layout>
                    <HeaderComponent ref={childRef} />
                    <Content>
                        <div className='body'>
                            <Row>
                                <Col span={18} style={{ width: "966px", background: "#FFFFFF", borderRadius: "7px 7px 7px 7px" }}>
                                    {/* 标题容器 */}
                                    <div style={{ height: "104px" }}>
                                        <StockChart code={code} type={type} renderTitleOnly onLogin={onLogin} />
                                    </div>
                                    {/* 表格内容容器 */}
                                    <div>
                                        <div className="tabs-container" >
                                            <Flex gap="small" justify="center" >
                                                <Button
                                                    onClick={() => onTabsChange('1')}
                                                    className={`tab-button tab-button1 ${type === 1 ? 'active-tab' : ''}`}
                                                >
                                                    十大流通股东
                                                </Button>
                                                <Button
                                                    onClick={() => onTabsChange('2')}
                                                    className={`tab-button tab-button2 ${type === 2 ? 'active-tab' : ''}`}
                                                    style={{marginLeft: '-8px'}}
                                                >
                                                    十大股东
                                                </Button>
                                            </Flex>
                                        </div>
                                        <div style={{ marginBottom: '0px' }}>
                                            <StockChart code={code} type={type} renderChartAndTable />
                                        </div> 
                                        <div style={{ marginTop: "10px" }}>
                                            <div className='row' style={{ marginBottom: '6px'}}>
                                                <div className='left title'>持仓明细</div>
                                                <div className='right update_time'></div>
                                                <div className='clear'></div>
                                            </div>
                                            <div className='tag-container'>
                                                <div className="scrollable-container" ref={scrollContainerRef}>
                                                    <Flex gap="small" className="tags-flex">
                                                        {dayList.length > 0 ? dayList.map((item) => (
                                                            <span 
                                                                key={item.day} 
                                                                onClick={() => onTagClick(item.day)} 
                                                                className={date === item.day ? "tag active" : "tag"}
                                                                ref={el => dateTagRefs.current[item.day] = el}
                                                            >
                                                                {item.show}
                                                            </span>
                                                        )) : ''}
                                                    </Flex>
                                                </div>
                                                {dayList.length > 0 && (
                                                    <Dropdown overlay={menu} placement="bottomRight">
                                                        <Button 
                                                            size="small" 
                                                            icon="···"
                                                            className="dropdown-button"
                                                        />
                                                    </Dropdown>
                                                )}
                                            </div>
                                            <div className='table' style={{ marginTop: '-6px'}}>
                                                <Table
                                                    size='small'
                                                    loading={false}
                                                    locale={{emptyText: "暂无数据" }} 
                                                    columns={columns}
                                                    dataSource={dataSource}
                                                    rowClassName={(record) => 
                                                        `custom-row ${selectedRowKey === record.code ? 'selected-row' : ''}`
                                                    }
                                                    onRow={(record) => ({
                                                        onClick: (event) => onRowClick(record, event),
                                                    })}
                                                    rowKey="code"
                                                    pagination={false}
                                                />
                                            </div>
                                            {exitDataSource.length > 0 && (
                                                <>
                                                    <div className='row' style={{ marginTop: '0px'}}>
                                                        <div className='left title' style={{
                                                            fontSize: 14,
                                                            color: '#666666',
                                                            lineHeight: '46px'
                                                        }}>
                                                            {type === 1 ? '较上个报告期退出十大流通股东' : '较上个报告期退出十大股东'}
                                                        </div>
                                                        <div className='right update_time'></div>
                                                        <div className='clear'></div>
                                                    </div>
                                                    <div className='table2'>
                                                        <Table
                                                            size='small'
                                                            loading={false}
                                                            locale={{emptyText: "暂无数据" }} 
                                                            scroll={{ "x": "max-content" }}
                                                            columns={exitColumns}
                                                            dataSource={exitDataSource}
                                                            rowClassName="custom-row2"
                                                            rowKey="index2"
                                                            pagination={false}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                                <Col span={6}>
                                    <div className='sidebar-container'>
                                        <HotPersonageSideberComponent/>
                                        <div style={{marginTop: "15px"}}></div>
                                        <IncreaseSidebarComponent type={type} />
                                    </div>         
                                </Col>
                            </Row>
                        </div>
                    </Content>
                    <FooterComponent/>
                </Layout>
            </Flex>
        </div>
    );
};
export default Particulars;
    